// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3ifSD","modalForm":"UpgradeEpcsModal_modalForm__wZ6zZ","modalFooter":"UpgradeEpcsModal_modalFooter__2tPaQ"};